export default __webpack_public_path__ + "static/media/delete.f48dde3a.svg";